import { forwardRef, useStyleConfig, chakra, Box as Box$1, Button as Button$1, Center, Link as Link$1 } from '@chakra-ui/react';
import { mapResponsive, theme } from '@hover/chakra-theme';
import { useCallback } from 'react';
import { includes } from '@hover/utilities';
import { motion as motion$1, useReducedMotionConfig, MotionConfig, AnimatePresence } from 'framer-motion';
import _omit from 'ramda/src/omit';
import 'ramda/src/pick';
import '@chakra-ui/system';
import 'ramda/src/has';
import 'tiny-warning';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import _mapObjIndexed from 'ramda/src/mapObjIndexed';
import 'ramda/src/join';
import 'ramda/src/identity';
import 'ramda/src/ifElse';
import 'ramda/src/map';
import 'ramda/src/split';
import 'ramda/src/concat';
import 'ramda/src/toLower';
import 'ramda/src/pipe';
import { keyframes } from '@emotion/react';
import { motion as motion$2, colorSchemes } from '@hover/chakra-theme/foundation';
import { buttonSize, buttonSizes } from '@hover/chakra-theme/components';
import { STROKE_ACCENT_CLASS } from '@hover/icons/constants';
import { transitions } from 'polished';
import { createContext } from '@chakra-ui/react-utils';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var stylesToOmit = ['transform'];
var stripMotionFromVariants = function stripMotionFromVariants(variants, strip) {
  return _mapObjIndexed(function (variant) {
    return strip ? _omit(stylesToOmit, variant) : variant;
  }, variants);
};
/**
 * Framer Motion's `motion` factory with types that work properly with system
 * components. Note that there a couple things to keep in mind when working
 * with motion components:
 *
 * - If you're going to spread external props into the component, make sure to
 *   type the props using `MotionPropsFor` (see example below).
 * - If the root component in your custom component is a `motion()` component,
 *   you must always forward a ref to it with `forwardRef` as Framer uses refs
 *   for some types of motion.
 *
 * @example
 * ```tsx
 * import { forwardRef, motion, MotionPropsFor, Box, BoxProps } from '@hover/blueprint';
 *
 * export interface MyAnimatedComponentProps extends MotionPropsFor<BoxProps> {
 *   isFoo?: boolean;
 * }
 *
 * const MotionBox = motion(Box);
 *
 * export const MyAnimatedComponent = forwardRef<MyAnimatedComponentProps, 'div'>(
 *   ({ isFoo, ...props }) => <MotionBox {...props}>{isFoo ? 'foo' : 'bar'} />
 * )
 * ```
 */
var motion = motion$1;
var SWIPE_THRESHOLD = 10000;

/**
 * Helper for invoking actions in response to swipe gestures. Given a swipe
 * axis and actions to invoke when swiping towards the start or end of said
 * axis, determine whether to invoke one of the provided actions depending on
 * whether the swipe in the respective direction passes the provided threshold.
 *
 * @param axis direction of swipe
 * @param start action to invoke when swiping towards start of axis
 * @param end action to invok when swiping towards end of axis
 * @param threshold force threshold that must be reached (distance * velocity)
 *
 * @example
 * ```tsx
 * import { motion, Image, onSwipe } from '@hover/blueprint';
 *
 * const MotionImage = motion(Image);
 *
 * <MotionImage
 *   drag="x"
 *   onDragEnd={
 *     onSwipe(
 *       'x',
 *       () => console.log('swiped left'),
 *       () => console.log('swiped right')
 *     )
 *   }
 * />
 * ```
 *
 * @returns event handler to pass to `onDragEnd`
 */
var onSwipe = function onSwipe(axis, start, end) {
  var threshold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : SWIPE_THRESHOLD;
  return function (_, _ref) {
    var offset = _ref.offset,
      velocity = _ref.velocity;
    var force = Math.abs(offset[axis]) * velocity[axis];
    if (force < -threshold) {
      end();
    } else if (force > threshold) {
      start();
    }
  };
};

var _excluded$6 = ["sizes"],
  _excluded2$1 = ["components"];
var getResponsiveSizeThemePrefix = function getResponsiveSizeThemePrefix(component) {
  return function (size) {
    return size ? "components.".concat(component, ".responsiveSizes.").concat(size.toString()) : '';
  };
};

/**
 * Helper used to emulate responsive behavior for component size presets
 * described here: https://github.com/chakra-ui/chakra-ui/issues/1028
 *
 * Hopefully we'll get this behavior natively in Chakra from `size`, `variant`
 * etc. soon
 *
 * @example
 * ```tsx
 * // Theme
 * export const Link = {
 *   baseStyle: {},
 *   responsiveSizes: { // <-- instead of `sizes`
 *     small: {
 *       font-size: 12px;
 *       line-height: 18p;
 *     },
 *     large: {
 *       font-size: 18px;
 *       line-height: 26px;
 *     }
 *   }
 * }
 *
 * // Component
 * interface Props {
 *   size: ResponsiveValue<'small' | 'large'>;
 * }
 *
 * const MyLink = (props: Props) =>
 *   <ChakraLink apply={getApplyForResponsiveSize('Link', props.size)} />
 *
 * // Usage
 * <MyLink size={{ mobile: 'small', desktop: 'large' }} />
 * ```
 *
 * @param component component name in theme (used to retrieve styles)
 * @param prop responsive size prop value
 * @returns function to be passed to Chakra's `apply` prop
 */
var getApplyForResponsiveSize = function getApplyForResponsiveSize(component, prop) {
  return prop === undefined ? undefined : mapResponsive(getResponsiveSizeThemePrefix(component), prop);
};

/**
 * Convert a Chakra component theme configuration to support responsive sizes
 *
 * @param theme component theme configuration
 * @returns responsive component theme configuration
 */
var makeComponentResponsive = function makeComponentResponsive(_ref) {
  var sizes = _ref.sizes,
    styles = _objectWithoutProperties(_ref, _excluded$6);
  return _objectSpread2({
    responsiveSizes: sizes
  }, styles);
};

/**
 * Convert specified components on a Chakra theme to suppot responsive sizes
 *
 * @param theme theme to transformm
 * @param componentNames names of components to convert to responsive sizes
 * @returns theme with specified components convertd to responsive sizes
 */
var makeThemeResponsive = function makeThemeResponsive(_ref2, componentNames) {
  var components = _ref2.components,
    theme = _objectWithoutProperties(_ref2, _excluded2$1);
  return _objectSpread2({
    components: _mapObjIndexed(function (styles, name) {
      return (
        // Chakra implemented responsive sizes, so this is going away soon
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        componentNames.includes(name) ?
        // Chakra implemented responsive sizes, so this is going away soon
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        makeComponentResponsive(styles) : styles
      );
    }, components)
  }, theme);
};

var _excluded2 = ["testId"];
var attribute = 'data-testid';

/**
 * Returns an object containing test ID *attribute* (e.g: `data-testid`)
 *
 * @example
 * const props = { testId: 'foo', bar: 'baz' };
 * <Component {...applyTestId(props)} />
 * // Equivalent
 * <Component data-testid="foo" />
 *
 * @param props - Props object with test ID prop
 *
 * @returns Object with test ID attribute
 */
var applyTestId = function applyTestId(_ref2) {
  var testId = _ref2.testId;
  return _defineProperty({}, attribute, testId);
};

/**
 * Replaces the test ID prop in supplied props object with a test ID *attribute* (e.g: `data-testid`)
 *
 * @example
 * const props = { testId: 'foo', bar: 'baz' };
 * <Component {...withTestId(props)} />
 * // Equivalent
 * <Component data-testid="foo" bar="baz" />
 *
 * @param props - Props object with test ID prop
 *
 * @returns Props object with test ID *attribute* in place of test ID prop
 */
var withTestId = function withTestId(_ref4) {
  var testId = _ref4.testId,
    props = _objectWithoutProperties(_ref4, _excluded2);
  return _objectSpread2(_objectSpread2({}, applyTestId({
    testId: testId
  })), props);
};

/**
 * Whether to disable layout animations based on user preference or
 * environment.
 *
 * Both Chakra and Framer Motion expose hooks to read the user preference from
 * CSS, but this should be the canonical hook that we use as there are other
 * cases to consider (like screenshots in Chromatic).
 */
var useIsMotionReduced = function useIsMotionReduced(override) {
  // This reads from _both_ the CSS value, and the context value set via
  // `MotionConfig`, which allows us to set `reducedMotion="always"` in a
  // `MotionConfig` that wraps every story to disable motion in Chromatic.
  var isReduced = useReducedMotionConfig();
  return override !== null && override !== void 0 ? override : !!isReduced;
};

var _excluded$5 = ["accent", "icon", "orientation", "role", "strokeWidth", "sx", "isInline", "isStatic"];
var Icon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$accent = _ref.accent,
    accent = _ref$accent === void 0 ? 'currentColor' : _ref$accent,
    IconComponent = _ref.icon;
    _ref.orientation;
    var _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'img' : _ref$role,
    strokeWidth = _ref.strokeWidth,
    sx = _ref.sx,
    isInline = _ref.isInline,
    isStatic = _ref.isStatic,
    props = _objectWithoutProperties(_ref, _excluded$5);
  var styles = useStyleConfig('Icon', props);

  // WTF: for some reason, this specific component was throwing hydration
  // mismatch errors when being server rendered (only in **web-react**, I
  // wasn't able to reproduce this in the documentation or demo application).
  // It turns out the issue was, for some reason, the style object properties
  // were in different orders which was producing a different checksum on the
  // client vs. the server. I think the true offender is somewhere in Chakra
  // or Emotion, but this'll do for now, pig.
  var sortedStyles = Object.fromEntries(Object.entries(styles).sort(function (_ref2, _ref3) {
    var _ref4 = _slicedToArray(_ref2, 1),
      a = _ref4[0];
    var _ref5 = _slicedToArray(_ref3, 1),
      b = _ref5[0];
    return a > b ? 1 : -1;
  }));
  var customStrokeWidth = strokeWidth ? {
    strokeWidth: strokeWidth
  } : {};
  var transition = isStatic ? {} : transitions(['color'], theme.motion.easings[250]);
  return jsx(chakra.svg, _objectSpread2(_objectSpread2(_objectSpread2({
    "aria-hidden": props.title ? 'false' : 'true',
    as: IconComponent,
    display: isInline ? 'inline' : undefined,
    margin: isInline ? 0 : undefined,
    role: role
  }, transition), withTestId(props)), {}, {
    __css: sortedStyles,
    ref: ref,
    sx: _objectSpread2(_objectSpread2(_objectSpread2({}, customStrokeWidth), sx), {}, _defineProperty({}, ".".concat(STROKE_ACCENT_CLASS), {
      stroke: accent
    }))
  }));
});
Icon.displayName = 'Icon';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _excluded$4 = ["children"];
var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$4);
  return jsx(Box$1, _objectSpread2(_objectSpread2({
    boxSizing: "border-box",
    display: "flex"
  }, withTestId(props)), {}, {
    ref: ref,
    children: children
  }));
});
Box.displayName = 'Box';

/* eslint-disable @typescript-eslint/no-redeclare */

var Copy = {
  LOADING: 'Loading'
};
var ProgressBarValue = {
  MAX: 100,
  MIN: 0
};

var _excluded$3 = ["label", "color", "speed", "size"];
var _templateObject;
var durations = {
  500: motion$2.animation.spin[500].duration,
  700: motion$2.animation.spin[700].duration
};
var spin = /*#__PURE__*/keyframes(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"])));
var Loader = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? Copy.LOADING : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary.600' : _ref$color,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? 500 : _ref$speed,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded$3);
  var styles = useStyleConfig('Icon', _objectSpread2({
    size: size
  }, props));
  var apply = getApplyForResponsiveSize('Icon', size);
  return jsx(Box, _objectSpread2(_objectSpread2({}, withTestId(props)), {}, {
    alignContent: "center",
    "aria-busy": true,
    "aria-label": label,
    "aria-valuemax": ProgressBarValue.MAX,
    "aria-valuemin": ProgressBarValue.MIN,
    color: color,
    justifyContent: "center",
    ref: ref,
    role: "progressbar",
    children: jsxs(chakra.svg, {
      animation: "".concat(durations[speed], "s linear 0s infinite normal none running ").concat(spin),
      apply: apply,
      "aria-hidden": "true",
      focusable: "false",
      role: "img",
      sx: styles,
      viewBox: "0 0 512 512",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsx("path", {
        d: "M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z",
        fill: "currentColor",
        opacity: 0.4
      }), jsx("path", {
        d: "M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z",
        fill: "currentColor"
      })]
    })
  }));
});

/**
 * This behavior should probably be constrained a bit more to simplify things,
 * but `circle` and `square` buttons get equal dimensions so this is a helper to
 * apply the dimensions
 *
 * @param equal whether `width` and `height` should be equal
 * @param props button props
 *
 * @returns props to be spread into butto
 */
var getEqualSizeProps = function getEqualSizeProps(equal, _ref) {
  var _ref2;
  var width = _ref.width,
    height = _ref.height,
    size = _ref.size;
  if (!equal) return {
    size: size
  };
  var dimension = // First, if `height` or `width` is set, apply a single dimensions to both
  (_ref2 = height !== null && height !== void 0 ? height : width) !== null && _ref2 !== void 0 ? _ref2 :
  // Otherwise, read the dimensions from the theme, taking into
  // account the fact that `size` can now be a responsive value
  mapResponsive(function (s) {
    var _buttonSizes$s;
    return includes(buttonSize, s) ? (_buttonSizes$s = buttonSizes[s]) === null || _buttonSizes$s === void 0 ? void 0 : _buttonSizes$s.height : buttonSizes["default"].height;
  }, size);
  return {
    size: undefined,
    paddingLeft: 0,
    paddingRight: 0,
    width: dimension,
    height: dimension
  };
};

var _excluded$2 = ["children", "color", "fill", "iconAfter", "isDisabled", "isLoading", "iconBefore", "label", "onClick", "shape", "size"];
var MotionCenter = /*#__PURE__*/motion(Center);
var MotionLoader = /*#__PURE__*/motion(Loader);
var iconSizes = {
  small: 'tiny',
  "default": 'small',
  medium: 'small',
  large: 'small'
};
var loaderSizes = {
  small: 'tiny',
  "default": 'small',
  medium: 'small',
  large: 'medium'
};
var transformForFill = function transformForFill(translate, transform) {
  return translate ? {
    transform: transform
  } : {};
};
var getVariants = function getVariants(translate, loader) {
  return {
    loading: _objectSpread2({
      opacity: loader ? 1 : 0
    }, transformForFill(translate, "translate3d(0, ".concat(loader ? 0 : -100, "%, 0)"))),
    idle: _objectSpread2({
      opacity: loader ? 0 : 1
    }, transformForFill(translate, "translate3d(0, ".concat(loader ? 100 : 0, "%, 0)")))
  };
};
var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref2;
  var children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? 'solid' : _ref$fill,
    iconAfter = _ref.iconAfter,
    isDisabled = _ref.isDisabled,
    isLoading = _ref.isLoading,
    iconBefore = _ref.iconBefore,
    label = _ref.label,
    onClick = _ref.onClick,
    _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? 'pill' : _ref$shape,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var isMotionReduced = useIsMotionReduced();
  var shouldSlide = fill !== 'minimal' && !isMotionReduced;
  var isEqual = shape === 'circle' || shape === 'square';

  // TODO: maybe we shouldn't be setting `aria-label` to the text content of
  // the button here? I'm not sure if it's actually harmful, but I'm leaving
  // it for now to avoid a potential breaking change
  var ariaLabel = (_ref2 = label !== null && label !== void 0 ? label : props['aria-label']) !== null && _ref2 !== void 0 ? _ref2 : typeof children === 'string' ? children : undefined;
  var iconSize = mapResponsive(function (s) {
    return iconSizes[s];
  }, size, 'small');
  var loaderSize = mapResponsive(function (s) {
    return loaderSizes[s];
  }, size, 'small');
  return jsx(Button$1, _objectSpread2(_objectSpread2(_objectSpread2({
    "aria-label": ariaLabel,
    borderRadius: includes(['square', 'box'], shape) ? '300' : '900',
    colorScheme: color,
    disabled: isDisabled || isLoading,
    isDisabled: isDisabled,
    onClick: onClick,
    variant: fill
  }, withTestId(props)), getEqualSizeProps(isEqual, _objectSpread2(_objectSpread2({}, props), {}, {
    size: size
  }))), {}, {
    ref: ref,
    children: jsxs(MotionConfig, {
      transition: theme.motion.framer.tight,
      children: [jsxs(MotionCenter, _objectSpread2(_objectSpread2({}, applyTestId({
        testId: 'wrapper'
      })), {}, {
        animate: isLoading ? 'loading' : 'idle',
        height: "100%",
        variants: getVariants(shouldSlide, false),
        width: "100%",
        children: [iconBefore && jsx(Icon, {
          icon: iconBefore,
          margin: "0 !important",
          marginRight: "200 !important",
          size: iconSize
        }), children, iconAfter && jsx(Icon, {
          icon: iconAfter,
          margin: "0 !important",
          marginLeft: "200 !important",
          size: iconSize
        })]
      })), jsx(AnimatePresence, {
        children: isLoading && jsx(MotionLoader, {
          animate: "loading",
          color: "inherit",
          exit: "idle",
          initial: "idle",
          position: "absolute",
          size: loaderSize,
          variants: getVariants(shouldSlide, true)
        })
      })]
    })
  }));
});
Button.displayName = 'Button';

var _excluded$1 = ["icon", "iconSize", "shape", "size"];
var IconButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
    iconSize = _ref.iconSize,
    _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? 'circle' : _ref$shape,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return jsx(Button, _objectSpread2(_objectSpread2({
    shape: shape,
    size: size
  }, props), {}, {
    ref: ref,
    children: jsx(Icon, {
      icon: icon,
      size: iconSize !== null && iconSize !== void 0 ? iconSize : mapResponsive(function (s) {
        return s ? iconSizes[s] : 'small';
      }, size)
    })
  }));
});
IconButton.displayName = 'IconButton';

var _createContext = /*#__PURE__*/createContext({
    name: 'ColorSchemeContext',
    strict: false
  }),
  _createContext2 = /*#__PURE__*/_slicedToArray(_createContext, 3),
  Provider = _createContext2[0],
  useContext = _createContext2[1];
  _createContext2[2];
var useColorScheme = function useColorScheme() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    colorScheme = _ref.colorScheme;
  var context = useContext();
  return _objectSpread2({
    colorScheme: colorScheme
  }, context);
};
var ColorSchemeProvider = function ColorSchemeProvider(_ref2) {
  var colorScheme = _ref2.colorScheme,
    variant = _ref2.variant,
    children = _ref2.children;
  return jsx(Provider, {
    value: {
      colorScheme: typeof colorScheme === 'string' && includes(colorSchemes, colorScheme) ? colorScheme : undefined,
      variant: variant
    },
    children: children
  });
};

var _excluded = ["children", "iconAfter", "iconBefore", "isMinimal", "label", "onChange", "onPress", "size"];
var iconProps = {
  color: 'inherit',
  height: '1em',
  margin: 0,
  width: '1em'
};
var Link = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _props$colorScheme;
  var children = _ref.children,
    iconAfter = _ref.iconAfter,
    iconBefore = _ref.iconBefore,
    _ref$isMinimal = _ref.isMinimal,
    isMinimal = _ref$isMinimal === void 0 ? false : _ref$isMinimal,
    label = _ref.label,
    onChange = _ref.onChange,
    onPress = _ref.onPress,
    sizeProp = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  var onClick = useCallback(function (event) {
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
    if (!props.disabled) onPress === null || onPress === void 0 ? void 0 : onPress(event);
  }, [onChange, props.disabled, onPress]);

  // We only want to default `size` when `Link` is rendered as a button,
  // otherwise we want it to inherit `font-size` and `line-height` by default
  var size = props.as === 'button' && !sizeProp ? 500 : sizeProp;
  var apply = getApplyForResponsiveSize('Link', size);
  return jsx(Link$1, _objectSpread2(_objectSpread2({
    "aria-label": label,
    onClick: onClick
  }, withTestId(props)), {}, {
    apply: apply,
    ref: ref,
    variant: isMinimal ? 'minimal' : 'underline',
    children: jsxs(ColorSchemeProvider, {
      colorScheme: (_props$colorScheme = props.colorScheme) !== null && _props$colorScheme !== void 0 ? _props$colorScheme : 'primary',
      children: [iconBefore && jsx(Icon, _objectSpread2(_objectSpread2({}, iconProps), {}, {
        icon: iconBefore,
        marginRight: "0.25em"
      })), children, iconAfter && jsx(Icon, _objectSpread2(_objectSpread2({}, iconProps), {}, {
        icon: iconAfter,
        marginLeft: "0.25em"
      }))]
    })
  }));
});
Link.displayName = 'Link';

export { Box as B, ColorSchemeProvider as C, Icon as I, Link as L, SWIPE_THRESHOLD as S, _objectWithoutProperties as _, _objectSpread2 as a, _taggedTemplateLiteral as b, _defineProperty as c, _slicedToArray as d, getVariants as e, Button as f, getApplyForResponsiveSize as g, IconButton as h, Loader as i, useIsMotionReduced as j, _arrayLikeToArray as k, _unsupportedIterableToArray as l, motion as m, makeThemeResponsive as n, onSwipe as o, stripMotionFromVariants as s, useColorScheme as u, withTestId as w };
